// components/ChangeProfilePictureModal.jsx
import React, { useState } from 'react';

const ChangeProfilePictureModal = ({ isOpen, onClose, currentImage, onSave }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(currentImage || '/Icons/boy.svg');

  if (!isOpen) return null;

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSave = () => {
    if (onSave) {
      onSave(selectedImage, previewUrl);
    }
    onClose();
  };

  const handleCancel = () => {
    setSelectedImage(null);
    setPreviewUrl(currentImage || '/Icons/boy.svg');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      {/* Backdrop with whitish blur */}
      <div 
        className="absolute inset-0 bg-white/40 backdrop-blur-md"
        onClick={handleCancel}
      />
      
      {/* Modal Card */}
      <div className="relative bg-white rounded-2xl border-[1.5px] border-primary-blue shadow-2xl w-full max-w-[25rem] 2xl:max-w-md">
        {/* Header with centered title */}
        <div className="relative px-8 pt-6 pb-5">
          <h2 className="text-xl font-semibold text-gray-900 text-center">
            Change Profile Picture
          </h2>
          <button
            onClick={handleCancel}
            className="absolute right-6 top-6 hover:opacity-70 transition-opacity"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#9CA3AF" strokeWidth="2" fill="none"/>
              <path d="M8 8L16 16M16 8L8 16" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {/* Profile Picture Preview */}
        <div className="px-8 pb-6 pt-2 flex flex-col items-center">
          <div className="relative w-48 h-48">
            {/* SVG Border as outer layer */}
            <div className="absolute inset-0 flex items-center justify-center">
              <img
                src="/change-profile-pic.svg"
                alt="Border"
                className="w-48 h-48 "
              />
            </div>
            
            {/* Profile Image in center */}
            <div className="absolute inset-0 flex items-center justify-center p-3">
              <img
                src={previewUrl}
                alt="Profile"
                className="w-28 h-28 rounded-full object-cover shadow-md"
              />
            </div>
            
            {/* Hidden file input */}
            <input
              type="file"
              id="profile-pic-upload"
              accept="image/*"
              onChange={handleImageChange}
              className="hidden"
            />
            
            {/* Upload button overlay */}
            <label
              htmlFor="profile-pic-upload"
              className="absolute bottom-4 right-4 bg-primary-blue text-white p-2 rounded-full cursor-pointer hover:bg-blue-700 transition-colors shadow-lg z-10"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </label>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="px-8 pb-6 pt-2 flex gap-3">
          <button
            onClick={handleSave}
            className="flex-1 py-3 bg-primary-blue text-white font-semibold rounded-lg hover:bg-blue-500 transition-colors text-base"
          >
            Save Changes
          </button>
          <button
            onClick={handleCancel}
            className="flex-1 py-3 bg-white border-[1.5px] border-primary-blue text-primary-blue font-semibold rounded-lg hover:bg-primary-blue hover:text-white transition-colors text-base"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangeProfilePictureModal;
